// extracted by mini-css-extract-plugin
module.exports = {"row":"InspectionList_row__1uU5Q","noflui":"InspectionList_noflui__2GoWL"};